import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getProfile, getUserData, logout } from '../../services/authService';
import './CuteSidebar.css';

function CuteSidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const storedUser = getUserData();
    if (storedUser) {
      setUserData(storedUser);
    } else {
      getProfile()
        .then((data) => setUserData(data))
        .catch((err) => {
          console.error('Error fetching profile:', err);
          navigate('/login');
        });
    }
  }, [navigate]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = [
    { path: '/home', icon: '🏠', label: 'Главная' },
    { path: '/orders', icon: '📦', label: 'Заказы' },
    { path: '/products', icon: '🍔', label: 'Продукты' },
    { path: '/organizations', icon: '🏢', label: 'Организации' },
    { path: '/roles', icon: '👥', label: 'Роли' },
  ];

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <div 
      className={`sidebar ${isExpanded ? 'expanded' : ''}`}
      onMouseEnter={() => setIsExpanded(true)}
      onMouseLeave={() => setIsExpanded(false)}
    >
      {/* Brand */}
      <div className="sidebar-brand">
        <div className="sidebar-logo">🍔</div>
        <div className="sidebar-brand-text">
          <span className="sidebar-brand-name">Embassy</span>
          <span className="sidebar-brand-sub">Burger</span>
        </div>
      </div>

      {/* Navigation */}
      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`sidebar-link ${isActive(item.path) ? 'active' : ''}`}
          >
            <span className="sidebar-icon">{item.icon}</span>
            <span className="sidebar-label">{item.label}</span>
            {isActive(item.path) && <div className="sidebar-indicator" />}
          </Link>
        ))}
      </nav>

      {/* User Section */}
      <div className="sidebar-user">
        {userData ? (
          <>
            <div className="sidebar-user-info">
              <div className="sidebar-avatar">
                {userData.full_name ? userData.full_name.charAt(0).toUpperCase() : '👤'}
              </div>
              <div className="sidebar-user-details">
                <span className="sidebar-user-name">{userData.full_name || 'Пользователь'}</span>
                <span className="sidebar-user-role">{userData.username}</span>
              </div>
            </div>
            <button onClick={handleLogout} className="sidebar-logout">
              <span className="sidebar-logout-icon">🚪</span>
              <span className="sidebar-logout-text">Выйти</span>
            </button>
          </>
        ) : (
          <div className="sidebar-loading">Загрузка...</div>
        )}
      </div>
    </div>
  );
}

export default CuteSidebar;
